var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "global-roomdesigner-selection" },
    [
      _vm.showModal
        ? _c(
            "global-modal",
            { on: { close: _vm.cancel } },
            [
              _c("template", { slot: "header" }, [
                _c("h2", [_vm._v(_vm._s(_vm.$t("roomdesigner.headline")))]),
              ]),
              _vm._v(" "),
              _c("template", { slot: "body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _vm.reference
                      ? _c("div", { staticClass: "row" }, [
                          _c("strong", { staticClass: "col-12" }, [
                            _vm._v("1 " + _vm._s(_vm.$t("roomdesigner.decor"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-4 col-md-2 col-xl-1 decor__col",
                              class: [
                                _vm.decorSelected(_vm.reference.title)
                                  ? "decor__col--selected"
                                  : "",
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.toggleSelection(
                                    _vm.reference.title
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "decor__col--icon icon-item icon-item--ghost",
                                },
                                [
                                  _c("span", {
                                    staticClass: "icon",
                                    class: [
                                      _vm.decorSelected(_vm.reference.title)
                                        ? "icon--check-square"
                                        : "icon--square",
                                    ],
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("global-material-tile", {
                                attrs: {
                                  "disable-link": true,
                                  entity: _vm.reference,
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.data.length
                      ? _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _c("strong", { staticClass: "col-12" }, [
                              _vm._v(
                                _vm._s(_vm.data.length) +
                                  " " +
                                  _vm._s(_vm.decorsLabel)
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.data, function (decor, index) {
                              return _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.page === _vm.groupTiles(index) ||
                                        _vm.tilesPerPage === null,
                                      expression:
                                        "page === groupTiles(index) || tilesPerPage === null",
                                    },
                                  ],
                                  staticClass:
                                    "col-4 col-md-2 col-xl-1 decor__col",
                                  class: [
                                    "group--" + _vm.groupTiles(index),
                                    _vm.decorSelected(decor.title)
                                      ? "decor__col--selected"
                                      : "",
                                  ],
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleSelection(decor.title)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "decor__col--icon icon-item icon-item--ghost",
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "icon",
                                        class: [
                                          _vm.decorSelected(decor.title)
                                            ? "icon--check-square"
                                            : "icon--square",
                                        ],
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("global-material-tile", {
                                    attrs: {
                                      "disable-link": true,
                                      entity: decor,
                                    },
                                  }),
                                ],
                                1
                              )
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.reference && _vm.data.length
                      ? _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _c("global-input-checkbox", {
                              staticClass: "selectAll",
                              attrs: {
                                label: _vm.$t("roomdesigner.selectAll"),
                                value: _vm.allDecorsSelected,
                              },
                              on: { input: _vm.toggleAll },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm.showPagination
                ? _c(
                    "template",
                    { slot: "pagination" },
                    [
                      _c("span", { staticClass: "pagination__indicator" }, [
                        _vm._v(_vm._s(_vm.decorsShown)),
                      ]),
                      _vm._v(" "),
                      _c("global-button", {
                        staticClass: "ignore-context pagination--prev",
                        class: _vm.page - 1 < _vm.lowerEnd ? "disabled" : "",
                        attrs: { icon: "arrow-left", theme: "secondary" },
                        on: {
                          click: function ($event) {
                            return _vm.changePage(_vm.page - 1)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("global-button", {
                        staticClass: "ignore-context pagination--prev",
                        class: _vm.page + 1 > _vm.upperEnd ? "disabled" : "",
                        attrs: { icon: "arrow-right", theme: "secondary" },
                        on: {
                          click: function ($event) {
                            return _vm.changePage(_vm.page + 1)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "global-button",
                {
                  attrs: { slot: "controls__left" },
                  on: { click: _vm.cancel },
                  slot: "controls__left",
                },
                [_vm._v(_vm._s(_vm.$t("roomdesigner.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "global-button",
                {
                  attrs: {
                    slot: "controls__right",
                    disabled: _vm.selectedDecors.length === 0,
                    href: _vm.openRoomdesigner,
                    target: "_blank",
                  },
                  on: { click: _vm.select },
                  slot: "controls__right",
                },
                [_vm._v(_vm._s(_vm.$t("roomdesigner.select")))]
              ),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }